export function formatDate(value: string) {
  return new Intl.DateTimeFormat('sk-SK').format(new Date(value))
}

export function addDays(date: Date | string, days: number): Date {
  const d = typeof date === 'string' ? new Date(date) : new Date(date.getTime())
  d.setDate(d.getDate() + days)
  return d
}

export function formatDateTimeWithSeconds(date: Date): string {
  const day = date.getDate()
  const month = date.getMonth() + 1
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  const seconds = date.getSeconds().toString().padStart(2, '0')
  return `${day}.${month}. ${hours}:${minutes}:${seconds}`
}

export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat('sk-SK', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(value))
}

export function getMonthYearString(date: Date) {
  return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`
}
